import { FormController } from "$root/third-party-integrations/react-hook-form";
import { valueByPath } from "$root/utils";
import type { StylableProps } from "@mdotm/shadcn/legacy/components";
import { Autocomplete, type AutocompleteProps, FormField } from "@mdotm/shadcn/mdotm/components";
import type { ReactNode } from "react";
import type { Control, FieldValues, FormState, Path } from "react-hook-form";

export type AutocompleteFieldProps<T extends FieldValues, TOptions> = StylableProps & {
	control: Control<T, any>;
	formState: FormState<T>;
	name: Path<T>;
	label: ReactNode;
} & Omit<AutocompleteProps<TOptions>, "value">;

export function AutocompleteField<T extends FieldValues, TOptions>({
	label,
	name,
	formState,
	control,
	className,
	style,
	...forward
}: AutocompleteFieldProps<T, TOptions>): React.JSX.Element {
	return (
		<FormField
			className={className}
			style={style}
			label={label}
			error={(valueByPath(formState.errors, name) as { message?: string })?.message}
		>
			{(fieldProps) => (
				<FormController
					control={control}
					name={name}
					render={({ field: { ref, ...controllerProps } }) => (
						<Autocomplete innerRef={ref} {...fieldProps} {...controllerProps} {...forward} />
					)}
				/>
			)}
		</FormField>
	);
}
